import { GlobeAltIcon } from '@heroicons/react/24/outline';
import { useIntl } from 'react-intl';

import { capitalizeFirstLetter } from 'src/utils/string';

import SecaoDefaultVerticalList from './SecaoDefaultVerticalList';

const SecaoIdiomas = ({ colaborador, isLoading }) => {
  const intl = useIntl();

  return (
    <SecaoDefaultVerticalList
      items={colaborador?.idiomas || []}
      isLoading={isLoading}
      icon={GlobeAltIcon}
      title={capitalizeFirstLetter(intl.formatMessage({ id: 'idiomas' }))}
      renderItem={(idioma) => (
        <>
          <div className="text-lg font-weight-bolder">
            {idioma?.lingua?.nome}
          </div>
          <div className="text-muted font-weight-bold mt-1">
            {`${intl.formatMessage({ id: 'nivelProficiencia' })}: ${
              idioma?.nivelProficiencia?.nome
            }`}
          </div>
        </>
      )}
    />
  );
};

export default SecaoIdiomas;
